import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: 400px;
  position: relative;
  z-index: 1000;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #142743;
`;

export const ModalTitle = styled.h2`
  font-family: Figtree;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.1px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FavoriteButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  background-color: transparent;
  width: 18px;
  height: 18px;
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 100%;
`;

export const Tag = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px; /* 150% */
  letter-spacing: -0.06px;

  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  border: 1px solid #345884;
  background: #213d64;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
`;

export const ImageContainer = styled.div`
  position: relative;
`;
export const UploadButton = styled.button`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.85px);

  display: flex;
  width: 100%;
  max-width: 248px;
  height: 44px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  position: absolute;
  cursor: pointer;

  outline: none;
  border: none;
  left: 50%;
  bottom: 8px;

  transform: translateX(-50%);

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
`;
export const Image = styled.img`
  width: 100%;
  border-radius: 12px;
  max-height: 260px;
  pointer-events: none;
  aspect-ratio: 9/6;
  object-fit: cover;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 15px;
  opacity: 0.4;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const NudifyContainer = styled.div`
  border-radius: 12px;
  background: #0e1c31;
  display: flex;
  padding: 6px 8px;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  flex-direction: row;
`;

export const NudifyText = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const LabelText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-align: left;
`;
export const PromptRow = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Textarea = styled.textarea`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  resize: vertical;
  min-height: 126px;
  outline: none;
`;
export const Input = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 12px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  transition: border-color 0.2s ease;

  background: #060e1a;
  padding: 6px 8px;

  &:focus {
    border-color: #2877d9;
  }

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;

export const Checkbox = styled.div`
  display: flex;
  padding: 6px 8px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 12px;
  background: #0e1c31;
`;

export const CheckboxText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const Button = styled.button`
  display: flex;
  padding: 6px 4px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex: 1;
  border-radius: 10px;
  border: ${(p) =>
    !p.$active ? "1px solid transparent" : "1px solid var(--200, #2877d9)"};
  background: ${(p) => (p.$active ? "#142743" : "transparent")};

  position: relative;
  transition: all 0.3s ease-in-out;
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  span {
    color: #fff;
    font-family: Figtree;
    opacity: 0.4;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.18px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 12px;
  background: #060e1a;
  flex: 1;
  padding: 2px;
  align-items: center;
`;
